/* eslint-disable no-restricted-syntax */
export function createAcMatcher(records) {
    const root = buildTrie(Object.fromEntries(records));
    let current = root;
    let buffer = '';
    let match = null;
    function handleUnmatch(char) {
        if (char === null) {
            current = root;
            if (match) {
                const result = match;
                match = null;
                result.postfix = buffer;
                buffer = '';
                return result;
            }
            const result = buffer;
            buffer = '';
            return result;
        }
        if (match) {
            current = root;
            match.postfix = buffer;
            const result = match;
            match = null;
            buffer = '';
            return result;
        }
        // 找到新的状态
        while (current.fail) {
            current = current.fail;
            if (current.children[char]) {
                current = current.children[char];
                break;
            }
        }
        const emitLength = buffer.length - current.level;
        const emit = buffer.slice(0, emitLength);
        buffer = buffer.slice(emitLength, buffer.length);
        return emit;
    }
    const matchChar = (char) => {
        if (char === null) {
            return handleUnmatch(char);
        }
        buffer += char;
        const next = current.children[char];
        if (!next) {
            return handleUnmatch(char);
        }
        current = next;
        if (current.data) {
            match = {
                type: 'match',
                value: current.data,
                prefix: '',
                postfix: '',
                match: [match ? match.match[0] + buffer : buffer],
            };
            buffer = '';
            if (Object.keys(current.children).length === 0) {
                return handleUnmatch(null);
            }
        }
        return null;
    };
    return matchChar;
}
export function buildTrie(record) {
    const root = {
        children: {},
        data: null,
        fail: null,
        level: 0,
    };
    for (const [tag, val] of Object.entries(record)) {
        let currentNode = root;
        for (const char of tag) {
            if (!currentNode.children[char]) {
                currentNode.children[char] = {
                    children: {},
                    data: null,
                    fail: root,
                    level: currentNode.level + 1,
                };
            }
            currentNode = currentNode.children[char];
        }
        currentNode.data = val;
    }
    // 构建AC自动机的fail跳转
    const queue = [];
    for (const char in root.children) {
        const child = root.children[char];
        child.fail = root;
        queue.push(child);
    }
    while (queue.length > 0) {
        const current = queue.shift();
        for (const char in current.children) {
            const child = current.children[char];
            queue.push(child);
            let failState = current.fail;
            while (failState !== root && !failState.children[char]) {
                failState = failState.fail;
            }
            if (failState.children[char]) {
                child.fail = failState.children[char];
            }
            else {
                child.fail = root;
            }
        }
    }
    return root;
}
